import { useAuth } from '../contexts/AuthContext';
import { useState, useEffect } from 'react';

interface UserDisplayInfo {
  displayName: string;
  avatarInitial: string;
  avatarUrl: string | null;
  avatarKey: number;
  isLoggedIn: boolean;
  email: string | null;
  isAdmin: boolean;
}

export const useUserDisplay = (): UserDisplayInfo => {
  const { user, profile, isAdmin } = useAuth();
  
  // Forçar re-render quando o profile mudar
  const [avatarKey, setAvatarKey] = useState(0);
  
  useEffect(() => {
    if (profile?.avatar_url) {
      setAvatarKey(prev => prev + 1);
    }
  }, [profile?.avatar_url]);

  const getFirstName = (fullName: string | null | undefined): string => {
    if (!fullName) return 'Usuário';
    return fullName.split(' ')[0];
  };

  const getDisplayName = (): string => {
    // Prioridade: profile.full_name > user_metadata.full_name > email_before_@
    if (profile?.full_name) {
      return getFirstName(profile.full_name);
    }
    if (user?.user_metadata?.full_name) {
      return getFirstName(user.user_metadata.full_name);
    }
    if (user?.email) {
      // Extrair nome do email como último recurso
      const emailName = user.email.split('@')[0];
      return emailName.charAt(0).toUpperCase() + emailName.slice(1);
    }
    return 'Usuário';
  };

  const getAvatarInitial = (): string => {
    if (profile?.full_name) {
      return profile.full_name.charAt(0).toUpperCase();
    }
    if (user?.user_metadata?.full_name) {
      return user.user_metadata.full_name.charAt(0).toUpperCase();
    }
    if (profile?.email) {
      return profile.email.charAt(0).toUpperCase();
    }
    if (user?.email) {
      return user.email.charAt(0).toUpperCase();
    }
    return 'U';
  };

  return {
    displayName: getDisplayName(),
    avatarInitial: getAvatarInitial(),
    avatarUrl: profile?.avatar_url || null,
    avatarKey,
    isLoggedIn: !!user,
    email: user?.email || profile?.email || null,
    isAdmin
  };
};